export default "__VITE_ASSET__73297f3b__"